import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import '../css/OurFinds.css';
import Footer from '../components/footer/Footer';
import Header from '../components/Header';

const OurFinds = () => {
    const [selectedImage, setSelectedImage] = useState(null);
    const [filter, setFilter] = useState('all');
    const [filteredFinds, setFilteredFinds] = useState([]);

    const finds = [
        { id: 25, image: 'find_25.jpg', title: 'Suspension globe en verre fumé 70s', category: 'decoration' },
        { id: 24, image: 'find_24.jpg', title: 'Plafonnier en cristal taillé vintage', category: 'decoration' },
        { id: 23, image: 'find_23.jpg', title: 'Lampadaire vintage rouge à 3 spots', category: 'decoration' },
        { id: 22, image: 'find_22.jpg', title: 'Fauteuil capitonné en velours vert', category: 'vintage' },
        { id: 21, image: 'find_21.jpg', title: 'Chaise longue en velours côtelé vert', category: 'vintage' },
        { id: 20, image: 'find_20.jpg', title: 'Tabourets en osier', category: 'meubles' },
        { id: 19, image: 'find_19.jpg', title: 'Cuisine vintage orange Rosières complète', category: 'vintage' },
        { id: 18, image: 'find_18.jpg', title: 'Carafes à whisky ', category: 'decoration' },
        { id: 17, image: 'find_17.jpg', title: 'Carafe Empoli 1960', category: 'decoration' },
        { id: 16, image: 'find_16.jpg', title: 'Fer à repasser Rowenta', category: 'electromenager' },
        { id: 15, image: 'find_15.jpg', title: 'Sèche cheveux', category: 'divers' },
        { id: 14, image: 'find_14.jpg', title: 'Bocaux et bouchons de bouteilles ', category: 'divers' },
        { id: 13, image: 'find_13.jpg', title: 'Balance de cuisine vintage', category: 'electromenager' },
        { id: 12, image: 'find_12.jpg', title: 'Couteau électrique', category: 'divers' },
        { id: 11, image: 'find_11.jpg', title: 'Livres Mickey et BD', category: 'vintage' },
        { id: 10, image: 'find_10.jpg', title: 'Horloge murale Vedette', category: 'decoration' },
        { id: 9, image: 'find_9.jpg', title: 'Téléphone à cadran', category: 'vintage' },
        { id: 8, image: 'find_8.jpg', title: 'Cafetière vintage fleurie', category: 'vintage' },
        { id: 7, image: 'find_7.jpg', title: 'Verres à motifs rouges', category: 'vintage' },
        { id: 6, image: 'find_6.jpg', title: 'Bac à glaçons pomme', category: 'vintage' },
        { id: 5, image: 'find_5.jpg', title: 'Trousse Hollywood vintage', category: 'vintage' },
        { id: 4, image: 'find_4.jpg', title: 'Paniers en osier', category: 'decoration' },
        { id: 3, image: 'find_3.jpg', title: 'Fauteuil en osier', category: 'meubles' },
        { id: 2, image: 'find_2.jpg', title: 'Desserte en bois', category: 'meubles' },
        { id: 1, image: 'find_1.jpg', title: 'Objets vintage divers', category: 'vintage' }
    ];

    const categories = [
        { id: 'all', name: 'Toutes', icon: '🔍' },
        { id: 'vintage', name: 'Sooo vintage', icon: '✨' },
        { id: 'meubles', name: 'Meubles', icon: '🪑' },
        { id: 'decoration', name: 'Décoration', icon: '🎨' },
        { id: 'electromenager', name: 'Électroménager', icon: '🔌' },
        { id: 'divers', name: 'Divers', icon: '📦' }
    ];

    // Filtrage des trouvailles
    useEffect(() => {
        if (filter === 'all') {
            setFilteredFinds(finds);
        } else {
            setFilteredFinds(finds.filter(find => find.category === filter));
        }
    }, [filter]);

    // Fonction pour ouvrir l'image en plein écran
    const openModal = (find) => {
        setSelectedImage(find);
    };

    // Fonction pour fermer le modal
    const closeModal = () => {
        setSelectedImage(null);
    };

    // Gestion des touches du clavier
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                closeModal();
            }
            if (e.key === 'ArrowRight' && selectedImage) {
                const currentIndex = filteredFinds.findIndex(find => find.id === selectedImage.id);
                const nextIndex = (currentIndex + 1) % filteredFinds.length;
                setSelectedImage(filteredFinds[nextIndex]);
            }
            if (e.key === 'ArrowLeft' && selectedImage) {
                const currentIndex = filteredFinds.findIndex(find => find.id === selectedImage.id);
                const prevIndex = (currentIndex - 1 + filteredFinds.length) % filteredFinds.length;
                setSelectedImage(filteredFinds[prevIndex]);
            }
        };

        if (selectedImage) {
            document.addEventListener('keydown', handleKeyDown);
            document.body.style.overflow = 'hidden';
        }

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.body.style.overflow = 'unset';
        };
    }, [selectedImage, filteredFinds]);

    return (
        <>
            <Helmet>
                <title>Nos trouvailles : objets vintage issus de nos débarras | CC Débarras 14</title>
                <meta name="description" content="Meubles, décoration vintage, électroménager : découvrez les objets récupérés lors de nos débarras sur la Côte Fleurie et revendus sur Leboncoin et Facebook Marketplace." />
                <link rel="canonical" href="https://ccdebarras14.fr/nos-trouvailles" />
                <meta property="og:title" content="Nos trouvailles : objets vintage issus de nos débarras | CC Débarras 14" />
                <meta property="og:description" content="Meubles, décoration vintage, électroménager : découvrez les objets récupérés lors de nos débarras sur la Côte Fleurie et revendus sur Leboncoin et Facebook Marketplace." />
                <meta property="og:url" content="https://ccdebarras14.fr/nos-trouvailles" />
                <meta property="og:type" content="website" />
            </Helmet>

            <Header />
            
            <div className="our-finds-component">
                <div className="our-finds-content">
                    {/* En-tête de la page */}
                    <div className="our-finds-header">
                        <h1>Nos Trouvailles</h1>
                        <p>Découvrez les trésors que nous avons récupérés lors de nos débarras</p>
                    </div>

                    {/* Filtres par catégorie */}
                    <div className="our-finds-filters">
                        {categories.map((category) => (
                            <button
                                key={category.id}
                                className={`our-finds-filter-btn ${filter === category.id ? 'active' : ''}`}
                                onClick={() => setFilter(category.id)}
                            >
                                <span className="our-finds-filter-icon">{category.icon}</span>
                                <span>{category.name}</span>
                            </button>
                        ))}
                    </div>

                    {/* Compteur de résultats */}
                    <div className="our-finds-results-info">
                        <p>{filteredFinds.length} trouvaille{filteredFinds.length > 1 ? 's' : ''}</p>
                    </div>

                    {/* Galerie des trouvailles */}
                    <div className="our-finds-gallery">
                        <div className="our-finds-grid">
                            {filteredFinds.map((find) => (
                                <div 
                                    key={find.id} 
                                    className="our-finds-item"
                                    onClick={() => openModal(find)}
                                >
                                    <img 
                                        src={`/img/finds/${find.image}`} 
                                        alt={find.title}
                                        className="our-finds-image"
                                        onError={(e) => {
                                            e.target.src = '/img/placeholder.jpg';
                                        }}
                                    />
                                    <div className="our-finds-overlay">
                                        <div className="our-finds-overlay-content">
                                            <h3>{find.title}</h3>
                                            <div className="our-finds-category-badge">
                                                {categories.find(cat => cat.id === find.category)?.icon}
                                                {categories.find(cat => cat.id === find.category)?.name}
                                            </div>
                                        </div>
                                        <div className="our-finds-zoom-icon">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"></path>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Message si aucun résultat */}
                    {filteredFinds.length === 0 && (
                        <div className="our-finds-no-results">
                            <div className="our-finds-no-results-icon">📦</div>
                            <h3>Aucune trouvaille dans cette catégorie</h3>
                            <p>Essayez de sélectionner une autre catégorie</p>
                        </div>
                    )}

                    {/* Modal pour l'image en plein écran */}
                    {selectedImage && (
                        <div className="our-finds-modal" onClick={closeModal}>
                            <div className="our-finds-modal-content" onClick={(e) => e.stopPropagation()}>
                                <button className="our-finds-modal-close" onClick={closeModal}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <line x1="18" y1="6" x2="6" y2="18"></line>
                                        <line x1="6" y1="6" x2="18" y2="18"></line>
                                    </svg>
                                </button>
                                
                                <button 
                                    className="our-finds-modal-nav our-finds-modal-prev" 
                                    onClick={() => {
                                        const currentIndex = filteredFinds.findIndex(find => find.id === selectedImage.id);
                                        const prevIndex = (currentIndex - 1 + filteredFinds.length) % filteredFinds.length;
                                        setSelectedImage(filteredFinds[prevIndex]);
                                    }}
                                >
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <polyline points="15,18 9,12 15,6"></polyline>
                                    </svg>
                                </button>
                                
                                <div className="our-finds-modal-image-container">
                                    <img 
                                        src={`/img/finds/${selectedImage.image}`} 
                                        alt={selectedImage.title}
                                        className="our-finds-modal-image"
                                    />
                                    <div className="our-finds-modal-info">
                                        <h3>{selectedImage.title}</h3>
                                        <div className="our-finds-modal-category">
                                            {categories.find(cat => cat.id === selectedImage.category)?.icon}
                                            {categories.find(cat => cat.id === selectedImage.category)?.name}
                                        </div>
                                    </div>
                                </div>
                                
                                <button 
                                    className="our-finds-modal-nav our-finds-modal-next" 
                                    onClick={() => {
                                        const currentIndex = filteredFinds.findIndex(find => find.id === selectedImage.id);
                                        const nextIndex = (currentIndex + 1) % filteredFinds.length;
                                        setSelectedImage(filteredFinds[nextIndex]);
                                    }}
                                >
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <polyline points="9,18 15,12 9,6"></polyline>
                                    </svg>
                                </button>
                                
                                <div className="our-finds-modal-counter">
                                    {filteredFinds.findIndex(find => find.id === selectedImage.id) + 1} / {filteredFinds.length}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            
            <Footer />
        </>
    );
};

export default OurFinds;